import * as AC from './actionTypes';

export const getSupervisors = (filters = {}) => ({
  type: AC.GET_SUPERVISORS_REQUEST,
  filters,
});

export const getSupervisorById = id => ({
  type: AC.GET_SUPERVISOR_DETAILS_REQUEST,
  id,
});

export const addSupervisor = (
  email,
  firstName,
  lastName,
  phoneNumber,
  address,
  birthday,
  elevatorIds,
) => ({
  type: AC.ADD_SUPERVISOR_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    phoneNumber,
    address,
    birthday,
    elevatorIds,
  },
});

export const editSupervisor = (
  email,
  firstName,
  lastName,
  phoneNumber,
  address,
  birthday,
  elevatorIds,
  id,
) => ({
  type: AC.EDIT_SUPERVISOR_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    phoneNumber,
    address,
    birthday,
    elevatorIds,
    id,
  },
});

export const deleteSupervisor = id => ({
  type: AC.DELETE_SUPERVISOR_REQUEST,
  id,
});
